import { IAttendancesVotes, SubmitPlayerGameVotesPayload } from "./../../../";
import server from "../Server";
import withErrorCheck from "../CheckError";

export const SubmitPlayerGameVotes = async (
  payload: SubmitPlayerGameVotesPayload
): Promise<Partial<IAttendancesVotes[]>> => {
  const votes: Partial<IAttendancesVotes[]> = [];
  for (let i = 0; i < payload.votes.length; i++) {
    const inserted = withErrorCheck(
      await server
        .from("GameAttendanceVotes")
        .insert({
          type: payload.votes[i].type,
          player_id: payload.votes[i].id,
          game_attendance_id: payload.votes[i].attendanceId,
        })
        .select()
    )[0];
    votes.push(inserted);
  }

  return votes;
};
